import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').EmbedIframeBlock}
 */
const EmbedIframeBlock = ({ url }) => {
    return (
        <section className='col-padding w-full'>
            <figure>
                <iframe
                    allow='autoplay'
                    loading='lazy'
                    src={url} />
            </figure>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default EmbedIframeBlock;
